import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { COMMUNITY_PAGES, COMMUNITY_HUB } from "@/data/communityPages";

// Hand-picked, high-demand communities for the homepage strip.
const FEATURED = [
  "property-snagging-al-furjan",
  "property-snagging-sobha-hartland",
  "property-snagging-dubai-hills-estate",
  "property-snagging-damac-lagoons",
];

export default function Communities() {
  return (
    <section id="communities" className="py-24 lg:py-28 bg-white border-t border-line" data-testid="home-communities">
      <div className="wrap">
        <SectionHead
          eyebrow="Inspections by community"
          title="Find your Dubai community."
          sub="Handover-ready guidance and a scope tailored to your community — with report delivery within the confirmed timeframe."
        />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {FEATURED.map((slug, i) => {
            const c = COMMUNITY_PAGES[slug];
            return (
              <Reveal key={slug} delay={(i % 4) * 0.05}>
                <Link
                  to={`/${slug}`}
                  data-testid={`home-community-${slug}`}
                  className="group flex flex-col justify-between h-full border border-line rounded-[14px] p-6 bg-white hover:border-blue hover:-translate-y-0.5 hover:shadow-sm transition-all"
                >
                  <div>
                    <span className="text-[0.68rem] font-mono-jb uppercase tracking-wide text-blue">{c.inspectionIntent}</span>
                    <h3 className="text-[1.1rem] mt-2 mb-1 group-hover:text-blue transition-colors">{c.communityName}</h3>
                    <div className="flex items-center gap-1.5 text-muted text-[0.82rem]"><MapPin size={13} className="text-blue" /> {c.developerName}</div>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-blue text-[0.82rem] font-semibold mt-5">
                    View inspection <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-8">
            <Link
              to={COMMUNITY_HUB}
              data-testid="home-communities-all"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] border border-line text-ink font-semibold bg-white hover:border-blue hover:text-blue transition-colors"
            >
              View all Dubai communities <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
